import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, CircularProgress } from "@mui/material";
import axios from "axios";
import { API_URL } from "../../config";

const ViewCatalogPage = () => {
    const { id } = useParams();
    const [menuLink, setMenuLink] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const response = await axios.get(
                    API_URL + `get_restaurant.php?id=${id}`, { withCredentials: true }
                );
                setMenuLink(response.data.menu_link);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching menu:", error);
                setLoading(false);
            }
        };

        fetchMenu();
    }, [id]);

    return (
        <Container maxWidth="sm" className="view-content-container">
            {loading ? (
                <CircularProgress />
            ) : (
                <div>
                    <Typography variant="h4" sx={{ justifyContent: 'center' }} gutterBottom>
                        Document View
                    </Typography>
                    <embed
                        src={API_URL + `${menuLink}`}
                        type="application/pdf"
                        width="100%"
                        height="600px"
                    />
                </div>
            )}
        </Container>
    );
};

export default ViewCatalogPage;
